
import html2canvas from 'html2canvas';

window.saveDom = html2canvas;

function resizeCanvas(canvas, targetW, targetH) {
  const resizedCanvas = document.createElement("canvas");
  resizedCanvas.width = targetW;
  resizedCanvas.height = targetH;
  const ctx = resizedCanvas.getContext("2d");

  ctx.drawImage(canvas, 0, 0, targetW, targetH);
  return resizedCanvas;
}

window.getScreenshotDiv = function () {
  const node = document.getElementById("screenShot");

  if (!node) {
    console.error("❌ Không tìm thấy phần tử #screenShot");
    return;
  }

  
  document.fonts.ready.then(() => {
    html2canvas(node, {
      useCORS: true,
      allowTaint: false,
      backgroundColor: null,
      scale: 2
    }).then(canvas => {
      // Resize về 2000x1000
      $("#screenShot").show();

      const resized = resizeCanvas(canvas, 1500, 530);

      // Dùng JPEG thay vì PNG cho nhẹ
      const dataUrl = resized.toDataURL("image/png", 0.8);

      const link = document.createElement("a");
      link.href = dataUrl;
      link.download = "sceenShot.jpg"; // đổi tên file .jpg
      link.click();

      $('#screenShot').hide();
      console.log("✅ Ảnh đã tải xong (2000x1000)");
    }).catch(err => {
      console.error("❌ Lỗi khi chụp ảnh bằng html2canvas:", err);
    });
  });
};